<ion-header mode="ios">
  <app-header [fromPayment]="fromPayment"
              [isHome]="isRestaurant"
              [ordersIsEmpty]="ordersIsEmpty"
              [hideOrdersAhead]="false"
              [isCollapse]="!isScrollPositionTop"
              [logo]="group?.logoImageUrl"
              [sourceBanner]="group?.bannerImageUrl"
              [isGroup]="true"
              [group]="group"
              (selectRestaurant)="scrollToRestaurant($event)"
              pageName="location">
    <ng-container *ngIf="placeCategoryTabsInHeader">
      <ng-container *ngTemplateOutlet="categoryTabs"></ng-container>
    </ng-container>
  </app-header>
  <div *ngIf="!placeCategoryTabsInHeader" class="container" [ngStyle]="{display: isWindmill ? 'none': 'block'}">
    <ng-container *ngTemplateOutlet="categoryTabs"></ng-container>
  </div>
</ion-header>

<!-- this is actually modal -->
<app-product-modal
  [defaultProduct]="selectedProduct"
  [restaurant]="selectedProductRestaurant"
  [locationId]="selectedProductRestaurant.locationId"
  [isClosed]="isRestaurantClosed"
  [allowScheduledPickups]="selectedProductRestaurant?.allowScheduledPickups"
  [isMobileEnabled]="selectedProductRestaurant?.isMobileEnabled"
  [isModal]="true"
  [enforceInventory]="selectedProductRestaurant?.enforceInventory"
  [hoursOfOperation]="selectedProductRestaurant?.hoursOfOperation"
  [currencySign]="restaurantStore.restaurantCountryInfo.currencySign"
  [isRestaurantHaveEnabledWorkDays]="isRestaurantHaveEnabledWorkDays"
  *ngIf="isShowProductModal"
  (close)="closeProductModal()"
  (addItem)="onAddItemToCart($event)"
>
</app-product-modal>

<app-tab-modal
  *ngIf="isShowTabModal"
  [isGroup]="true"
  (close)="closeTabModal()"
></app-tab-modal>

<app-age-gate-modal
  *ngIf="isShowAgeGateModal"
  (close)="closeAgeGateModal()"
>
</app-age-gate-modal>

<app-restaurant-closed-modal
  *ngIf="isShowClosedModal && restaurants[0]"
  [restaurant]="restaurants[0]"
  [restaurants]="restaurants"
  [filteredWorkHours]="restaurantsFilteredWorkHours[0]"
  [restaurantsFilteredWorkHours]="restaurantsFilteredWorkHours"
  [isGroup]="true"
  (close)="closeRestaurantClosedModal()"
></app-restaurant-closed-modal>

<ion-content [scrollEvents]="true" (ionScrollEnd)="changeLastTabFlag()">
  <div class="container container--padding-bottom">
    <div *ngIf="this.isTaxes && restaurantCategories.length > 0; else spinner"
         class="container__content menu-slides">
      <ion-list #category *ngFor="let restaurantCategory of restaurantCategories; index as i" class="menu-items" [class.menu-items--collapse]="restaurantCategory.hideItems">
        <ion-list-header class="menu-items__header" (click)="showCategoryItems(restaurantCategory)"  *ngIf="restaurantCategory.items.length > 0">
            <span class="menu-items__header-text">
              {{restaurantCategory.name}}
            </span>
          <ion-icon class="menu-items__header-icon" [class.menu-items__header-icon-reverse]="restaurantCategory.hideItems" ios="ios-arrow-dropup" md="md-arrow-dropup"></ion-icon>
        </ion-list-header>
        <hr class="menu-items__header-line" *ngIf="restaurantCategory.items.length > 0"/>
        <li class="menu-items__item-wrapper"
            *ngFor="let product of restaurantCategory.items"
            (click)="showProductModal(product)">
          <app-product-details
            [class.menu-items__item]="!isCategoryProductHidden(product, restaurantCategories)"
            [productCollapseState]="productCollapseState(product, restaurantCategories)"
            [product]="product"
            [truncateDescription]="true"
            [enforceInventory]="isProductSold(product)"
            [currencySign]="restaurantStore.restaurantCountryInfo.currencySign"
            [hasPadding]="true"
            [isFavorite]="isFavorite(product)"
            [orderBotUserId]="orderBotUserId">
          </app-product-details>
        </li>
      </ion-list>

      <ion-list class="menu-items menu-items__spinner" *ngIf="restaurantStore.loadItemsInProgress">
        <div class="spinner-wrapper">
          <app-spinner></app-spinner>
        </div>
      </ion-list>
    </div>
    <ng-template #spinner>
      <div class="spinner-wrapper">
        <app-spinner></app-spinner>
      </div>
    </ng-template>

  </div>
</ion-content>

<ion-footer class="checkout-footer" *ngIf="showCheckout">


  <div class="checkout-footer__container">
    <button class="checkout-footer__button" (click)="goToCheckout()" [disabled]="cartStore.updateCartInProgress">
          <span>
            <ion-icon name="cart"></ion-icon>
            {{cartStore.textForCheckoutBtn}}
          </span>
    </button>
  </div>
</ion-footer>

<ng-template #categoryTabs>
  <div class="container__content unscrollable-content" [class.unscrollable-content--is-collapse]="!isScrollPositionTop">
    <div *ngIf="showCategoryTabsLeftArrow" class="categories__arrow-wrapper">
      <div class="categories__arrow categories__arrow--left">
        <ion-icon name="arrow-back" mode="ios" (click)="scrollToPreviousCategoryTabs()"></ion-icon>
      </div>
    </div>
    <div #categoryWrapper class="categories__wrapper">
      <ul #categoryTabContainer class="categories" *ngIf="restaurantCategories.length">
        <div *ngFor="let category of restaurantCategories; index as i; last as isLast">
          <li #categoryTab class="categories__item"  *ngIf="!isHideCategory(category)">
            <button
              #rightButton
              type="button"
              class="categories__btn"
              [class.categories__btn--is-colapse]="!isScrollPositionTop"
              [class.categories__btn--active]="activeItemIndex === i"
              (click)="scrollToCategory(i, isLast)"
            >
              {{category?.name}}
            </button>
          </li>
        </div>
      </ul>
    </div>
    <div *ngIf="showCategoryTabsRightArrow" class="categories__arrow-wrapper">
      <div class="categories__arrow categories__arrow--right">
        <ion-icon name="arrow-forward" mode="ios" (click)="scrollToNextCategoryTabs()"></ion-icon>
      </div>
    </div>
  </div>
</ng-template>
